<template>
	<div v-show="isActive" class="ks-tab-content">
		<slot></slot>
	</div>
</template>

<script>
export default {
	props: {
		"label": {
			type: String,
			required: true
		},
		"name": {
			type: [String, Number],
			default: ""
		},
		"to": {
			type: [String, Object],
			default: ""
		},
		"disabled": {
			type: Boolean,
			default: false
		},
		"submenu": {
			type: Array,
			default: function () { return [] }
		}
	},
	data () {
		return {
			isActive: false,
			tabsParent: null
		}
	},
	mounted () {
		var parent = this.$parent
		while (parent && !parent.registerTab) {
			parent = parent.$parent
		}
		if (parent) {
			this.tabsParent = parent
			parent.registerTab(this)
		}
	},
	beforeDestroy () {
		if (this.tabsParent) {
			this.tabsParent.unregisterTab(this)
		}
	}
}
</script>
